export const isUserClient = user => user.glpiactiveprofile === "Cliente";
